import React from 'react';
import {Outlet} from 'react-router-dom';

function HomePage(): JSX.Element {
    return (
        <div className="l-container">
            <Outlet />
        </div>
    );
}

export default HomePage;
